export enum EmployeeMsgNotifyType {
    EMAIL = 1,
    SMS = 2,
    STOREMESSAGE = 3,
    ONLINEONLY = 4,
    PUSHNOTIFICATION = 5,
}
